import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadixSelect } from 'components/common/RadixSelect';
import { VariantRow } from 'utils/resourceVariants/resourceVariants';
import * as SC from './ResourceVariantPicker.styled';

export interface ResourceVariantPickerProps {
  counts: Record<string, number>;
  maxFor: (row: VariantRow) => number;
  onChange: (rowKey: string, count: number) => void;
  portalContainer?: HTMLElement | null;
  rows: VariantRow[];
  tierName: string;
}

const ResourceVariantPicker = ({
  counts,
  maxFor,
  onChange,
  portalContainer,
  rows,
  tierName,
}: ResourceVariantPickerProps) => {
  const { t: translate } = useTranslation();

  return (
    <SC.RowList className="resource-variant-picker">
      {rows.map((row) => {
        const max = maxFor(row);
        const isSoldOut = row.available === 0;
        return (
          <SC.Row key={row.key} className="resource-variant-picker__row">
            <SC.RowLabel $dimmed={isSoldOut}>
              {isSoldOut
                ? translate('resourceValueSoldOut', { label: row.label })
                : row.label}
            </SC.RowLabel>
            <SC.SelectWrapper>
              <RadixSelect
                aria-label={`${tierName} ${row.label}`}
                className="resource-variant-select"
                disabled={max === 0 && !counts[row.key]}
                onValueChange={(value) => onChange(row.key, Number(value))}
                options={Array.from({ length: max + 1 }, (_, count) => ({
                  label: String(count),
                  value: String(count),
                }))}
                portalContainer={portalContainer}
                value={String(counts[row.key] ?? 0)}
              />
            </SC.SelectWrapper>
          </SC.Row>
        );
      })}
    </SC.RowList>
  );
};

export default ResourceVariantPicker;
